import { msg } from '@/services/isomorphic/I18NService';
import type { DTO } from '@/type-utils';
import { makeObservable, observable } from 'mobx';
import {
  validEmail,
  validPhoneNumber
} from '@/react/view-models/Form/validation-utils';
import { FormModel, validatable } from '../../../Form';
import type { IContactForm } from './IContactForm';
import { forms_field_email } from "@/lang/__generated__/ahnu/forms_field_email";
import { forms_field_phone } from "@/lang/__generated__/ahnu/forms_field_phone";

/** Represents a form for customer names entry. */
export class ContactInfoFormModel
  extends FormModel<IContactForm>
  implements IContactForm
{
  /** @inheritdoc */
  @observable
  @validatable({
    get name() {
      return msg(forms_field_email);
    },
    validations: [validEmail]
  })
  public email: string;

  /** @inheritdoc */
  @observable
  @validatable({
    get name() {
      return msg(forms_field_phone);
    },
    validations: [validPhoneNumber]
  })
  public phoneNumber: string;

  /** @inheritdoc */
  public constructor(dto: DTO<IContactForm>) {
    super(dto);

    this.email = dto.email;
    this.phoneNumber = dto.phoneNumber;

    makeObservable(this);
  }

  /** @inheritdoc */
  public toDTO(): DTO<IContactForm> {
    return { email: this.email, phoneNumber: this.phoneNumber };
  }
}
